import { defineStore } from 'pinia';
import { HighAuthLogin } from '@tencent/wphk-act-base-framework';

const LOGIN_ACTID = 'promoter_2206';

export const useLogin = defineStore({
  id: 'loginStore',

  state: () => ({
    highAuthLogin: {} as any,
  }),

  getters: {},

  actions: {
    // 初始化高授权
    init() {
      const highAuthLogin = new HighAuthLogin(LOGIN_ACTID);
      this.highAuthLogin = highAuthLogin;
    },
  },
});
